import { useClearAuthKeys } from 'api/authentication/usePrivateKey';
import GuiContext from 'config/context/guiContext';
import { LogoutIcon } from 'features/navigation/assets/icons/icons';
import styles from './LogOut.module.css';
import { useContext } from 'react';

const LogOut = () => {
    const { clearAuthKeys } = useClearAuthKeys();

    const {
        logOut,
    } = useContext(GuiContext);

    const handleLogout = async () => {
        try {
            await clearAuthKeys();
            logOut();
        } catch (error) {
            // console.error("Error during logout process:", error);
        }
    }
    return (
        <button
            className={styles.logout_btn}
            onClick={handleLogout}
            aria-label="Logout"
        >
            <LogoutIcon />
        </button>
    )
}

export default LogOut